import React from 'react';
import PropTypes from 'prop-types'
import { useFormContext, useController } from "react-hook-form";
import * as R from "ramda";
import { ErrorMessage } from "@hookform/error-message";
import AddMoreButton from "./AddMoreButton";
import Checkbox from "../Checkbox";

const CheckboxGroup = (
  { options,
    name,
    handleChange,
    isMoreAction,
    handleAddMoreItem,
    handleRemoveMoreItem
  }) => {
  const { control } = useFormContext()
  const {
    field: { value, onChange, ref, ...inputProps },
    formState: { errors }
  } = useController({ name, control })

  const checkedValues = R.is(Array, value) ? value : [value]

  const onChangeExtend = checkboxValue => e => {
    let newValue = [...checkedValues]
    const checked = e.currentTarget.checked
    if(checked) {
      newValue = [...newValue, checkboxValue]
    } else {
      newValue = R.without([checkboxValue], newValue)
    }
    onChange(newValue)
    handleChange(name, newValue)
  }

  const handleAddMoreButton = (item) => {
    handleAddMoreItem(name, item)
    onChangeExtend(item.value)({ currentTarget: { checked: true }})
  }
  const handleRemoveMoreButton = (item) => () => {
    handleRemoveMoreItem(name, item)
    onChangeExtend(item.value)({ currentTarget: { checked: false }})
  }

  return (
    <>
      <ErrorMessage
        errors={errors}
        name={name}
        render={({ message }) => (
          <small className="text-danger">
            {message}
          </small>
        )}
      />
      {options.map(option => {
        return (
          <div key={option.value} className='d-flex align-items-center'>
            <Checkbox
              disabled={option.disabled}
              value={option.value}
              label={option.label}
              checked={checkedValues.includes(option.value)}
              onChange={onChangeExtend(option.value)}
              inputRef={ref}
              {...inputProps}
            />
            { option.custom &&
              <span className='ms-2 cursor-pointer' onClick={handleRemoveMoreButton(option)}>
                <i className='fas fa-minus-square text-danger fs-2' />
              </span>
            }
          </div>

        );
      })}
      {
        isMoreAction &&
        <AddMoreButton onClick={handleAddMoreButton}/>
      }
    </>
  )
}

CheckboxGroup.defaultProps = {
  handleChange: () => {},
  handleAddMoreItem: () => {},
  handleRemoveMoreItem: () => {},
}

CheckboxGroup.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    disabled: PropTypes.bool.isRequired,
    custom: PropTypes.bool.isRequired
  })),
  isMoreAction: PropTypes.bool,
  handleAddMoreItem: PropTypes.func,
  handleRemoveMoreItem: PropTypes.func,
}

export default CheckboxGroup


